// @flow
import React, {type Node} from 'react'

type Props = $ReadOnly<{
  className?: string,
  title?: string,
}>

function AgentBadge({className = '', title = 'Agent'}: Props): Node {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 28"
      fill="none"
      role="img"
      aria-label={title || 'Agent'}
    >
      {title && <title>{title}</title>}
      <line x1="12" y1="2" x2="12" y2="5" stroke="#888" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="1.5" r="1.5" fill="#888" />
      <rect x="4" y="5" width="16" height="16" rx="3" fill="#888" />
      <circle cx="9" cy="12.5" r="2" fill="#fff" />
      <circle cx="15" cy="12.5" r="2" fill="#fff" />
      <path d="M9 17 Q12 19 15 17" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <rect x="1" y="10.5" width="2.5" height="5" rx="1" fill="#888" />
      <rect x="20.5" y="10.5" width="2.5" height="5" rx="1" fill="#888" />
    </svg>
  )
}

export default AgentBadge
